import { render, staticRenderFns } from "./EmployeeAccreditation.vue?vue&type=template&id=61a3d94a&"
import script from "./EmployeeAccreditation.vue?vue&type=script&lang=js&"
export * from "./EmployeeAccreditation.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeAccreditation.vue?vue&type=style&index=0&id=61a3d94a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports